import React from "react"
import { useForm } from "react-hook-form"

const MAX_STEPS = 4

const IndexPage = () => {
  const {
    register,
    watch,
    handleSubmit,
    setError,
    getValues,
    clearErrors,
    formState: { errors, isValid },
  } = useForm({ mode: "all" })
  const [formStep, setFormStep] = React.useState(0)
  const [firstName, setFirstName] = React.useState("")
  const [lastName, setLastName] = React.useState("")

  const setApiError = (error) => {
    setError('apiError', { message: error });
    setTimeout(() => {
      clearErrors();
    }, 3000);
  }

  const handleStepCompletion = async () => {
    if (formStep === 2) {
      try {
        setApiError(`Processing payment...`);
        console.log("Processing payment...");
        const endpoint = `https://oscar-venmo.herokuapp.com/verify_payment?userID=${getValues("venmoID")}&numTickets=${getValues("numTickets")}`
        const response = await fetch(endpoint, { headers: { "Access-Control-Allow-Origin": "*" } });
        console.log(response);
        const json = await response.json();
        console.log("JSON", json);
        const serverMessage = json.message;
        if (!response.ok) {
          clearErrors();
          setApiError(`Error Message: ${serverMessage}. Please contact GT Oscar Band`);
          return;
        } else {
          console.log("user data", json.user);
          const { first_name, last_name, username } = json.user;
          setFirstName(first_name);
          setLastName(last_name);
          clearErrors();
          setError('apiSuccess', { message: serverMessage });
          setTimeout(() => {
            clearErrors();
            setFormStep(cur => cur + 1);
          }, 2000);
          return;
        }
      } catch (error) {
        clearErrors();
        setApiError(error);
        return;
      }
    }
    isValid && setFormStep(cur => cur + 1)
  }
  const handleFormCompletion = async () => {
    try {
      console.log("important");
      console.log(firstName, lastName);
      const endpoint = `https://oscar-venmo.herokuapp.com/send_email?userID=${getValues("venmoID")}&email=${getValues("email")}&firstName=${firstName}&lastName=${lastName}&numTickets=${getValues("numTickets")}`;
      const response = await fetch(endpoint, { headers: { "Access-Control-Allow-Origin": "*" } });
      console.log(response);
      const json = await response.json();
      const serverMessage = json.message;
      if (!response.ok) {
        setApiError(`Error Message: ${serverMessage}. Please contact GT Oscar Band`);
        return;
      } else {
        setError('apiSuccess', { message: serverMessage });
        setTimeout(() => {
          clearErrors();
          setFormStep(cur => cur + 1);
        }, 2000);
        return;
      }
    } catch (error) {
      setApiError(error);
      return;
    }
  }
  return (
    <div className="min-h-screen bg-gray-900 flex flex-col items-start text-gray-900 antialiased relative">
      <div
        style={{
          clipPath: "polygon(0 0, 100% 0, 100% 80%, 0% 100%)",
          height: "34rem",
        }}
        className="absolute bg-gray-800 inset-x-0 top-0"
      ></div>
      <div className="mx-auto z-10 mt-48 text-center">
        <h1 className="text-white text-5xl font-semibold">
          Puchase <span className="text-yellow-500">Tickets</span>
        </h1>
        <p className="text-gray-200 mt-2">
          🎸 GT OSCAR BAND SPRING 2022 FINAL CONCERT 🎸
        </p>
      </div>
      <div className="max-w-xl w-full mt-24 mb-24 rounded-lg shadow-2xl bg-white mx-auto overflow-hidden z-10">
        {formStep < MAX_STEPS && (
          <div className="h-2 w-full bg-gray-200">
            <div
              style={{ width: `${((formStep + 1) / MAX_STEPS) * 100}% ` }}
              className="h-full bg-yellow-400"
            ></div>
          </div>
        )}
        <div className="px-16 py-10">
          {formStep <= MAX_STEPS && (
            <div
              className={`flex ${formStep === 0 ? "justify-end" : "justify-between"
                } items - center mb - 6 font - medium text - sm`}
            >
              {formStep > 0 && (
                <button
                  onClick={() => setFormStep(cur => cur - 1)}
                  className="flex items-center text-gray-400 hover:text-gray-500 focus:outline-none"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    className="w-5 mr-2"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M15 19l-7-7 7-7"
                    />
                  </svg>
                  Previous
                </button>
              )}
              <p className="">
                Step {formStep + 1} of {MAX_STEPS}
              </p>
            </div>
          )}
          <form onSubmit={handleSubmit(handleFormCompletion)}>
            {formStep >= 0 && (
              <section className={formStep === 0 ? "block" : "hidden"}>
                <h2 className="font-semibold text-3xl mb-8">
                  Venmo ID
                </h2>
                <label htmlFor="venmoID">
                  Please input your Venmo ID without @ sign <br /> <i>(EX: gtoscarband)</i> <i style={{ color: "blue" }}> *CASE-SENSITIVE*</i>
                  {/* <br /> <b style={{ color: "blue" }}> *CASE-SENSITIVE* </b> */}
                </label>
                <input
                  type="text"
                  id="venmoID"
                  name="venmoID"
                  className="text-input"
                  ref={register({
                    required: {
                      value: true,
                      message: "Please type your venmoID",
                    },
                  })}
                />
                {(errors.venmoID &&
                  <p className="text-red-600 text-sm mt-2">
                    {errors.venmoID.message}
                  </p>
                )}
              </section>
            )}
            {formStep >= 1 && (
              <section className={formStep === 1 ? "block" : "hidden"}>
                <h2 className="font-semibold text-3xl mb-8">
                  Number of Tickets
                </h2>
                <div className="block mt-6">
                  <input
                    name="numTickets"
                    className="p-3 text-gray-600 rounded mr-3 border-2 border-gray-300 ring-0 focus:ring-0 focus:ring-offset-0 focus:border-0 cursor-pointer"
                    type="radio"
                    value={1}
                    ref={register({
                      required: true,
                    })}
                  />
                  <span>
                    1 Ticket ($5)
                  </span>
                </div>
                <div className="block mt-6">
                  <input
                    name="numTickets"
                    className="p-3 text-gray-600 rounded mr-3 border-2 border-gray-300 ring-0 focus:ring-0 focus:ring-offset-0 focus:border-0 cursor-pointer"
                    type="radio"
                    value={2}
                    ref={register({
                      required: true,
                    })}
                  />
                  <span>
                    2 Tickets ($6)
                  </span>
                </div>
              </section>
            )}
            {formStep >= 2 && (
              <section className={formStep === 2 ? "block" : "hidden"}>
                <h2 className="font-semibold text-3xl mb-8">
                  Venmo Payment
                </h2>
                <label htmlFor="venmoID">
                  Open Venmo and send <b>@gtoscarband</b> a payment of <b>{parseInt(getValues("numTickets")) === 1 ? "$5" : "$6"}</b>.
                  After you are done, click <b>"Complete Payment"</b> .<br />
                  <div style={{ textAlign: "center", justifyContent: "center" }}>
                    <img src="https://i.postimg.cc/mgdRbQfc/Warning.jpg" alt="Warning" />
                    <i style={{ color: "red" }}> <b>WARNING:</b> PLEASE TURN THIS OPTION <b>OFF</b> </i>
                  </div>
                </label>
                {(errors.apiError &&
                  <p className="text-red-600 text-sm mt-2">
                    {errors.apiError.message}
                  </p>
                ) || (errors.apiSuccess && (
                  <p className="text-green-600 text-sm mt-2">
                    {errors.apiSuccess.message}
                  </p>
                ))}
              </section>
            )}
            {formStep >= 3 && (
              <section className={formStep === 3 ? "block" : "hidden"}>
                <h2 className="font-semibold text-3xl mb-8">
                  Email Address
                </h2>
                <label htmlFor="email">Please input your email <br /><i>(EX: gatech.oscarband@gmail.com)</i></label>
                <input
                  type="text"
                  id="email"
                  name="email"
                  className="text-input"
                  ref={register({
                    required: {
                      value: true,
                      message: "Please type your email",
                    },
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: "Invalid email format"
                    }
                  })}
                />
                {(errors.email &&
                  <p className="text-red-600 text-sm mt-2">
                    {errors.email.message}
                  </p>
                ) || (errors.apiError &&
                  <p className="text-red-600 text-sm mt-2">
                    {errors.apiError.message}
                  </p>
                  ) || (errors.apiSuccess && (
                    <p className="text-green-600 text-sm mt-2">
                      {errors.apiSuccess.message}
                    </p>
                  ))}
              </section>
            )}
            {formStep >= MAX_STEPS && (
              <section>
                <h2 className="font-semibold text-3xl mb-8">
                  Thank you for your puchase!
                </h2>
                <p> 📪 Please check your inbox for a confirmation email 📪 </p>
              </section>
            )}
            {formStep < MAX_STEPS && (
              <button
                disabled={!isValid}
                onClick={formStep === MAX_STEPS - 1 ? undefined : handleStepCompletion}
                type={formStep === MAX_STEPS - 1 ? "submit" : "button"}
                className="mt-6 bg-gray-600 text-white rounded px-8 py-6 w-full disabled:bg-gray-400"
              >
                {formStep === 2 ? "Confirm Payment" : (formStep === MAX_STEPS - 1 ? "Send Email" : "Next")}
              </button>
            )}
            {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
          </form>
        </div>
      </div>
    </div>
  )
}

export default IndexPage
